import { IconNames } from '@blueprintjs/icons';
import { DropdownMenu } from '@strata/react-dropdown-menu';
import { Icon } from '@strata/react-status-icons';
import * as PropTypes from 'prop-types';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { AppRoutes } from 'services/routes';

const backToDestination = {
    route: AppRoutes.opportunitiesList,
    text: 'Opportunities',
};

export const OpportunityRowMenu = ({ treatmentId, row }) => {
    const navigate = useNavigate();
    const [showDropdown, setShowDropdown] = useState(false);

    const { referralId, payerId, canFix } = row;

    const dropdownMenuOptions = [
        ...(canFix
            ? [
                  {
                      text: 'Fix Invalid Data',
                      onItemClick: () =>
                          navigate(AppRoutes.opportunityDetails(referralId), {
                              state: { backToDestination },
                          }),
                  },
              ]
            : []),
        {
            text: 'Go to Patient Treatment',
            onItemClick: () =>
                navigate(AppRoutes.treatmentDetails(payerId, treatmentId), {
                    state: { backToDestination },
                }),
        },
    ];

    return (
        <DropdownMenu
            isOpen={showDropdown}
            menuItemArray={dropdownMenuOptions}
            onInteraction={(nextOpenState, e) => {
                e?.stopPropagation();
                setShowDropdown(nextOpenState);
            }}
        >
            <Icon
                icon={IconNames.MORE}
                intent={Icon.Intent.SECONDARY}
                title="Opportunity Menu"
                className="sds_referral-grid__row-menu-button"
            />
        </DropdownMenu>
    );
};

OpportunityRowMenu.propTypes = {
    treatmentId: PropTypes.string.isRequired,
    row: PropTypes.shape({
        referralId: PropTypes.string,
        payerId: PropTypes.string,
        canFix: PropTypes.bool,
    }).isRequired,
};
